import commonTranslations from './i18n.en';
import dashboardTranslations from '../../dashboard/i18n.en';
import domainSettingsTranslations from '../../domain_settings/i18n.en';
import inventoryTranslations from '../../inventory/i18n.en';
import loginTranslations from '../../login/i18n.en';
import manageTranslations from '../../manage/i18n.en';

// React only
import AvailabilityCheck from '../../../../src-react/screens/ProposalBuilder/AvailabilityCheck/i18n.en';

export default {
    ...commonTranslations,
    ...AvailabilityCheck,
    dashboard: dashboardTranslations,
    domainSettings: domainSettingsTranslations,
    inventory: inventoryTranslations,
    login: loginTranslations,
    manage: manageTranslations,
};
